import React from 'react'

const EstatePartner = ({partner, providerUrl,selected}) => {
  const titleClassName = selected ? "title-estate" : "title-estate-alternate"
  const triangleClassName = selected ? "triangle" : "triangle-alternate"
  return <span>
    <div className={titleClassName}><div><a _href={providerUrl} target='_blank'>{partner}</a></div></div>
      <div className={triangleClassName}></div>      
  </span>
 
}
export default EstatePartner



/** WEBPACK FOOTER **
 ** ./app/components/EstatePartner.jsx
 **/